

export const ActionResponseEnum = {
    UNAUTHORIZED : 'unauthorized' ,
    REDIRECT : 'redirect' ,
}